import { useState } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_PRICER_API_BASE_URL;

export default function useDeleteBatchApi() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const execute = async (batchId) => {
        setError(undefined);
        setLoading(true);

        try {
            await axios.post(`${BASE_URL}/status/event`, {
                batchId,
                eventType: 'Batch',
                eventName: 'BatchDeleted',
                eventDate: new Date().toISOString(),
                source: 'MRPPortal'
            });
        } catch (e) {
            setError(e);
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        execute
    };
}